import React from "react";

export const FacebookLogo = ({ color }) => {
  return (
    <svg
      className={`w-full h-auto max-h-full ${color}`}
      xmlSpace="preserve"
      viewBox="303.72 368.74 11.08 22.96"
    >
      <path d="M306.18 391.7h4.51v-11.9h3.49v-3.49h-3.49v-2.63c0-1.06.77-1.68 3.67-1.27l.44-3.49c-6.15-.41-9.23-.82-8.62 7.39h-2.46v3.49h2.46v11.9z" />
    </svg>
  );
};
